import React from 'react';

const Type = ({ order }) => {
 const { veneer, millings } = order;
 return <td>{veneer ? 'Fornir' : millings.length ? 'CNC' : ''}</td>;
};

export default Type;
